import CryptoJS from 'crypto-js';
import { getHookSecretKey } from './config';

/** Browser-safe hex -> UTF-8 string decode (replaces Buffer.from(hex).toString()). */
function hexToUtf8(hex: string): string {
  return CryptoJS.enc.Hex.parse(hex).toString(CryptoJS.enc.Utf8);
}
function xorWithKey(text: string, key: string): string {
  let result = '';
  for (let i = 0; i < text.length; i += 1) {
    const charCode = text.charCodeAt(i);
    const keyChar = key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode ^ keyChar);
  }
  return result;
}
function customDecrypt(encryptedText: string): string {
  return xorWithKey(encryptedText, 'secret');
}
function getAesKey(): string {
  const encryptedText = hexToUtf8(getHookSecretKey());
  return customDecrypt(encryptedText);
}
export function decodeData(data: unknown, path?: string): unknown {
  if (data == null || typeof data === 'object') {
    return data;
  }
  if (typeof data !== 'string') {
    return data;
  }
  const decryptedText = getAesKey();
  try {
    try {
      return JSON.parse(data);
    } catch {
      let tmpData = hexToUtf8(data);
      tmpData = CryptoJS.AES.decrypt(tmpData, decryptedText).toString(CryptoJS.enc.Utf8);
      return JSON.parse(tmpData);
    }
  } catch (error) {
    let isDev = false;
    try {
      isDev = Boolean((import.meta as unknown as {
        env?: {
          DEV?: boolean;
        };
      }).env?.DEV);
    } catch {
      isDev = false;
    }
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error('decode data', path, error);
    }
    return '';
  }
}